import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const RelationshipWithMutual = ({
  refRelationHuman,
  refCreditDateHuman,
  refTypeOfCreditHuman,
  refCreditAmountHuman,
  refAmountOfFeesHuman,
  refInstallmentAmountHuman,
  refLoanBankHuman,
  refAffiliateHuman,
  refCreditHuman,
}) => {
  const data = useLocation();

  const [relationshipWithMutual, setRelationshipWithMutual] = useState({
    relationshipType: data.state.data.RelationshipWithMutual.relation || "",
    creditDate: data.state.data.RelationshipWithMutual.creditDate || "",
    creditType: data.state.data.RelationshipWithMutual.typeOfCredit || "",
    creditAmount: data.state.data.RelationshipWithMutual.amountOfCredit || "",
    amountOfFees: data.state.data.RelationshipWithMutual.amountOfFees || "",
    feeAmount: data.state.data.RelationshipWithMutual.installmentAmount || "",
    loanBank: data.state.data.RelationshipWithMutual.loanBank || "",
    affiliate: data.state.data.RelationshipWithMutual.affiliate || "",
    credit: data.state.data.RelationshipWithMutual.credit || "",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate-amebo">Relación con la mutual</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate">Tipo de relación:</label>
          <select
            ref={refRelationHuman}
            className="inputupdate"
            defaultValue={relationshipWithMutual.relationshipType}
            onChange={(e) =>
              setRelationshipWithMutual({
                ...relationshipWithMutual,
                relationshipType: e.target.value,
              })
            }
          >
            <option value="Socio">Socio</option>
            <option value="Proveedor">Proveedor</option>
            <option value="Fondista">Fondista</option>
          </select>
        </div>
      </div>
      {relationshipWithMutual.relationshipType === "Socio" && (
        <div>
          <div className="displayinputupdatebox">
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Fecha de crédito:</label>
              <input
                ref={refCreditDateHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.creditDate}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    creditDate: e.target.value,
                  })
                }
              />
            </div>
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Tipo de crédito:</label>
              <input
                ref={refTypeOfCreditHuman}
                className="inputupdate"
                disabled
                type="text"
                defaultValue={relationshipWithMutual.creditType}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    creditType: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="displayinputupdatebox">
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Monto de crédito:</label>
              <input
                ref={refCreditAmountHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.creditAmount}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    creditAmount: e.target.value,
                  })
                }
              />
            </div>
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Cantidad de cuotas:</label>
              <input
                ref={refAmountOfFeesHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.amountOfFees}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    amountOfFees: e.target.value,
                  })
                }
              />
            </div>
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Monto de la cuota:</label>
              <input
                ref={refInstallmentAmountHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.feeAmount}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    feeAmount: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="displayinputupdatebox">
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Entidad del Prestamo:</label>
              <input
                ref={refLoanBankHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.loanBank}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    loanBank: e.target.value,
                  })
                }
              />
            </div>
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Afiliado:</label>
              <input
                ref={refAffiliateHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.affiliate}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    affiliate: e.target.value,
                  })
                }
              />
            </div>
            <div className="inputboxupdate">
              <label className="tittleinputupdate">Credito:</label>
              <input
                ref={refCreditHuman}
                className="inputupdate"
                type="text"
                defaultValue={relationshipWithMutual.credit}
                onChange={(e) =>
                  setRelationshipWithMutual({
                    ...relationshipWithMutual,
                    credit: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RelationshipWithMutual;
